<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="`option-${index}`"
    >
      <div :class="$style.option">
        <input 
          type="checkbox"
          :id="`${uniqueId}-${index}`"
          :class="$style.checkbox"
          @change="toggleValue(option)"
        >
        <label
          :for="`${uniqueId}-${index}`"
        >
          {{option}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false
    },
    options: {
      type: Array,
      required: false
    }
  },
  computed: {
    uniqueId() {
      return `input-${this._uid}`;
    }
  },
  methods: {
    toggleValue(value) {
      const newValue = [...this.value];
      if (!newValue.includes(value)) {
        newValue.push(value);
      } else {
        newValue.splice(newValue.indexOf(value), 1);
      }

      this.$emit('update:value', newValue);
    }
  }
}
</script>

<style lang="scss" module>
.option {
  &:not(:last-child) {
    margin-bottom: 4px;
  }
}

.checkbox {
  position: relative;
  top: 1px;
}
</style>
